module.exports = "/assets/data/09de4245244dc8c5cd8d96d7892331e4-B97.data.json";